export const enum StorageKeys {
  AudioPlayerPlaybackSpeed = 'audioplayer_playbackSpeed',
  AudioDevicePreferences = 'audioDevicePreferences',
  AuthData = 'authData',
  AuthRedirect = 'authRedirect',
  CallsPageSearchParams = 'calls-page-search-params',
  Experiments = 'experiments',
  CallPop = 'callPop',
  LastUsedFaxPhoneNumber = 'lastUsedFaxPhoneNumber',
  LastUsedOutboundPhoneNumber = 'lastUsedOutboundPhoneNumber',
  AppSettings = 'app-settings',
  PbxAppSettings = 'pbx-app-settings',
  UserSessionData = 'user-session-data',
  ContactsLs = 'contacts-ls',
  FaxLs = 'fax-ls',
  AppVersionBanner = 'appVersionBanner',
  RequiredUpdateShown = 'requiredUpdateShown',
  NotificationsBanner = 'notificationsBanner',
  FaxEmailConfirmations = 'faxEmailConfirmations',
  SiteNav = 'sitenav',
  MessageDrafts = 'messageDrafts',
  WebphoneTabState = 'webphoneTabState',
  RecentCallsList = 'recentCallsList',
  RecentCallMap = 'recentCallMap',
  BlockedNumbers = 'blockedNumbers',
  DontShowAgain = 'dont-show-again',
  SpeedDial = 'speedDial',
  DesktopAppDetection = 'desktopAppDetection',
  /** sessionStorage: this tab already handed off to (or stayed out of) the desktop app. */
  DesktopAppHandoff = 'desktopAppHandoff',
  /** Remote announcement state, keyed by `userId:id@version`. */
  Announcements = 'announcements',
  /** Signatures of announcement payload issues already sent to Sentry. */
  AnnouncementIssues = 'announcementIssues',
  ClockSkewBanner = 'clockSkewBanner',
}
